import request from "../utils/request";

export const getAllSteps = async () => {
    return await request.get("/chatbot");
};

export const updateStep = async (data) => {
    return await request.post("/chatbot/update", { data });
};

export const createStep = async (stepData, prevStepId = null) => {
    return await request.post("/chatbot/create-step", { prevStepId, stepData });
};

export const deleteStep = async (id) => {
    return await request.post("/chatbot/delete-step/" + id);
};

export const getAllChatBotTicketTags = async () => {
    return await request.get("/chatbot/ticket-tags");
};
